import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import translate from "@insite/client-framework/Translate";
import { getSafeExternalUrl } from "@WhiteCap/Common/Utillities/SafeRedirect";
import { OrderModel, OrderSettingsModel } from "@insite/client-framework/Types/ApiModels";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
// eslint-disable-next-line spire/fenced-imports
import CustomSmallHeadingAndText from "@WhiteCap/Components/CustomSmallHeadingAndText";
// eslint-disable-next-line spire/fenced-imports
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import loadOrder from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/LoadOrder";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MultipleDeliveryStatus from "@WhiteCap/Components/MultipleDeliveryAndStatus";
import OrderDetailsKebabMenu from "@WhiteCap/Components/OrderDetailsKebabMenu";
import ProofOfDeliveryComponent from "@WhiteCap/Components/ProofOfDeliveryComponent";
import ProofOfDeliveryWillCallComponent from "@WhiteCap/Components/ProofOfDeliveryWillCallComponent";
import StatusLableAndHeading from "@WhiteCap/Components/StatusLableAndHeading";
import loadPODData from "@WhiteCap/Handlers/PODOrderHistory/PODHandler";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { FC, useMemo, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    language: state.context.session.language,
    orderListData: state.WhiteCap.orderStatus.OrderData?.erpOrders,
    isLoading: state.WhiteCap.podDataStore.isLoading,
});
const mapDispatchToProps = {
    loadPODData,
    loadOrder,
};
interface OwnProps {
    order: OrderModel;
    indexNumber: number;
    orderSettings: OrderSettingsModel;
    extendedStyles?: OrderSummaryCardStyles;
}

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface OrderSummaryCardStyles {
    orderSummaryCardGridItem?: GridItemProps;
    container?: GridContainerProps;
    pageTypeLinkGridItem?: GridItemProps;
    orderNumberGridItem?: GridItemProps;
    orderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    statusGridItem?: GridItemProps;
    statusHeadingAndText?: SmallHeadingAndTextStyles;
    webOrderNumberGridItem?: GridItemProps;
    webOrderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    totalGridItem?: GridItemProps;
    totalHeadingAndText?: SmallHeadingAndTextStyles;
    orderDateHeader?: DataTableHeaderProps;
    orderNumberHeader?: DataTableHeaderProps;
    shipToHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    customerPOHeader?: DataTableHeaderProps;
    orderTotalHeader?: DataTableHeaderProps;
    reorderHeader?: DataTableHeaderProps;
    orderDateCells?: DataTableCellProps;
    orderNumberCells?: DataTableCellProps;
    shipToCells?: DataTableCellProps;
    statusCells?: DataTableCellProps;
    customerPOCells?: DataTableCellProps;
    orderTotalCells?: DataTableCellProps;
    reorderCells?: DataTableCellProps;
    trackButton?: ButtonPresentationProps;
    grayDash?: SmallHeadingAndTextStyles;
    deliveryrHeadingAndText?: SmallHeadingAndTextStyles;
    multipleLink?: LinkPresentationProps;
    multipleDeliveryAndStatusWraaper?: InjectableCss;
    multipleDeliveryHeading?: TypographyProps;
}

export const orderSummaryCardStyles: OrderSummaryCardStyles = {
    orderSummaryCardGridItem: {
        width: 12,
        css: css`
            padding: 0 20px;
            max-width: 500px;
        `,
    },
    container: { gap: 5 },
    pageTypeLinkGridItem: { width: 12 },
    orderNumberGridItem: { width: 6 },
    statusGridItem: { width: 6 },
    webOrderNumberGridItem: { width: 6 },
    totalGridItem: { width: 6 },
    trackButton: {
        css: css`
            font-size: 14px !important;
            padding-left: 4px;
            padding-right: 4px;
            font-weight: 500 !important;
            span {
                font-size: 14px !important;
                font-weight: 500 !important;
                padding-left: 4px;
                padding-right: 4px;
            }
        `,
    },
    orderNumberHeadingAndText: {
        heading: {
            css: css`
                color: ${getColor("text.main")};
                text-align: center;
                font-weight: 400;
                font-size: 14px;
            `,
        },
        text: {
            css: css`
                color: ${getColor("text.main")};
                font-size: 16px;
                text-align: center;
                font-weight: 500;
            `,
        },
    },
    grayDash: {
        heading: {
            css: css`
                color:${getColor("text.main")};
                font-weight: 400;
                font-size: 14px;
                text-align: center;
                }             
            `,
        },
        text: {
            css: css`
                color: gray;
                font-weight: bold;
                text-align: center;
            `,
        },
    },
    deliveryrHeadingAndText: {
        heading: {
            css: css`
                color: ${getColor("text.main")};
                text-align: center;
                font-weight: 400;
                font-size: 12px;
            `,
        },
        text: {
            css: css`
                text-transform: capitalize !important;
                color: ${getColor("text.main")};
                font-size: 14px !important;
                text-align: center;
                font-weight: 500;
            `,
        },
    },
    multipleLink: {
        typographyProps: {
            css: css`
                font-size: 14px !important;
                font-weight: 500;
                text-align: center !important;
                text-decoration: none; /* Ensure no underline */
                outline: none !important;
                border: none !important;
                box-shadow: none !important;
            `,
        },
        css: css`
            &:focus {
                outline: none;
            }
        `,
    },
    multipleDeliveryAndStatusWraaper: {
        css: css`
            flex-direction: column;
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
    multipleDeliveryHeading: {
        css: css`
            font-size: 12px;
            text-transform: uppercase;
            font-weight: 400;
        `,
    },
};

const useTextRefs = () => {
    const deliveryTextRefs = useMemo(() => new Map<string, React.RefObject<HTMLDivElement | null>>(), []);
    const statusTextRefs = useMemo(() => new Map<string, React.RefObject<HTMLDivElement | null>>(), []);

    const getOrCreateRef = (map: Map<string, React.RefObject<HTMLDivElement | null>>, orderNumber: string) => {
        if (!map.has(orderNumber)) {
            map.set(orderNumber, React.createRef<HTMLDivElement>());
        }
        return map.get(orderNumber);
    };

    return {
        getOrCreateDeliveryTextRef: (orderNumber: string) => getOrCreateRef(deliveryTextRefs, orderNumber),
        getOrCreateStatusTextRefs: (orderNumber: string) => getOrCreateRef(statusTextRefs, orderNumber),
    };
};

const OrderSummaryCard: FC<Props> = ({
    language,
    order,
    orderSettings,
    isLoading,
    indexNumber,
    extendedStyles,
    loadOrder,
    loadPODData,
}) => {
    const [styles] = React.useState(() => mergeToNew(orderSummaryCardStyles, extendedStyles));

    const { getOrCreateDeliveryTextRef, getOrCreateStatusTextRefs } = useTextRefs();

    const [PODstate, setPODState] = useState({
        isModalOpen: false,
        selectedIndex: 0,
        poNumber: "",
        isWillCallPod: false,
    });
    const isTrueOrUndefined = (value?: boolean) => value === true || value === undefined;

    const orderDateDisplay = getLocalizedDateTime({
        dateTime: order.orderDate,
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    const orderNumber = order.erpOrderNumber || order.webOrderNumber;

    const loadPODDataHandler = (
        id: string,
        properties: any,
        arrayindex: number,
        po: string,
        isWillCallPod: boolean,
    ) => {
        setPODState({
            isModalOpen: true,
            selectedIndex: arrayindex,
            poNumber: po,
            isWillCallPod,
        });
        if (isWillCallPod) {
            loadOrder({
                orderNumber: id,
                sTEmail: "",
                sTPostalCode: "",
            });
        }
        loadPODData({ orderNumber: id, id: properties.podId, isWillCallPod });
    };
    const closeModal = () => {
        setPODState({
            isModalOpen: false,
            selectedIndex: 0,
            poNumber: "",
            isWillCallPod: false,
        });
    };

    const trackHandler = (url: string | URL | undefined) => {
        const safeUrl = getSafeExternalUrl(url);
        if (safeUrl) {
            window.open(safeUrl, "_blank");
        }
    };

    const [isDeliveryModalIsOpen, setIsDeliveryModalIsOpen] = useState<string | null>(null);
    const [isStatusModalIsOpen, setIsMultipleStatusClickHandler] = useState<string | null>(null);

    const MultipleDeliveryClickHandler = (orderNumber: string) => {
        setIsDeliveryModalIsOpen(isDeliveryModalIsOpen === orderNumber ? null : orderNumber);
        setIsMultipleStatusClickHandler(null);
    };

    const MultipleStatusClickHandler = (orderNumber: string) => {
        setIsDeliveryModalIsOpen(null);
        setIsMultipleStatusClickHandler(isStatusModalIsOpen === orderNumber ? null : orderNumber);
    };

    const closeMultipleDeliveryModal = () => {
        setIsDeliveryModalIsOpen(null);
        setIsMultipleStatusClickHandler(null);
    };

    return (
        <>
            <DataTableRow>
                <DataTableCell {...styles.orderDateCells} data-test-selector="orderHistoryTable_tableCell_date">
                    {(order.erpOrderNumber || order.webOrderNumber) && (
                        <CustomSmallHeadingAndText
                            // eslint-disable-next-line spire/avoid-dynamic-translate
                            heading={translate("ORDER #")}
                            text={order.erpOrderNumber !== "" ? order.erpOrderNumber : order.webOrderNumber}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>
                <DataTableCell {...styles.orderTotalCells}>
                    <SmallHeadingAndText
                        heading={translate("From Quote")}
                        text={order.webOrderNumber !== "" ? order.webOrderNumber : "-"}
                        extendedStyles={
                            order.webOrderNumber !== ""
                                ? { ...styles.orderNumberHeadingAndText } // Apply original styles if quoteNumber is defined and not empty
                                : { ...styles.grayDash }
                        }
                    />
                </DataTableCell>
                <DataTableCell
                    {...styles.orderNumberCells}
                    data-test-selector="orderHistoryTable_tableCell_orderNumber"
                >
                    {" "}
                    {order.orderDate && (
                        <SmallHeadingAndText
                            heading={translate("ORDER DATE")}
                            text={
                                order.orderDate
                                    ? getLocalizedDateTime({
                                          dateTime: new Date(order.orderDate),
                                          language,
                                      })
                                    : ""
                            }
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>

                <DataTableCell {...styles.orderTotalCells}>
                    {order.orderGrandTotalDisplay && (
                        <SmallHeadingAndText
                            heading={translate("Total")}
                            text={order.orderGrandTotalDisplay}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>
                <DataTableCell {...styles.orderTotalCells}>
                    {order.properties?.orderLinesCount && (
                        <SmallHeadingAndText
                            heading={translate("Items")}
                            text={order.properties?.orderLinesCount}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />
                    )}
                </DataTableCell>
                <DataTableCell {...styles.orderTotalCells}>
                    {order.properties?.isMultipleShipment?.toLowerCase() === "true" ? (
                        <StyledWrapper {...styles.multipleDeliveryAndStatusWraaper}>
                            <Typography {...styles.multipleDeliveryHeading}>{translate("DELIVERY")}</Typography>
                            <Link {...styles.multipleLink} onClick={() => MultipleDeliveryClickHandler(orderNumber)}>
                                <StyledWrapper ref={getOrCreateDeliveryTextRef(orderNumber)}>
                                    <Typography>{translate("Multiple")}</Typography>
                                </StyledWrapper>
                            </Link>

                            <MultipleDeliveryStatus
                                parentRef={getOrCreateDeliveryTextRef(orderNumber)}
                                onHandleClose={() => closeMultipleDeliveryModal()}
                                orderNumber={orderNumber}
                                isModalIsOpen={isDeliveryModalIsOpen === orderNumber}
                                properties={order.properties}
                                shipmentPackages={order.shipmentPackages}
                            />
                        </StyledWrapper>
                    ) : (
                        order.shipViaDescription && (
                            <SmallHeadingAndText
                                heading={translate("DELIVERY")}
                                text={translate("{0}", order?.shipViaDescription?.toLowerCase() ===  "sales person delivery" ? "Sales Rep" : order?.shipViaDescription)}
                                extendedStyles={styles.deliveryrHeadingAndText}
                            />
                        )
                    )}
                </DataTableCell>

                <DataTableCell {...styles.shipToCells}>
                    {order.properties.hasPod.toLocaleLowerCase() === "true" &&
                    order.properties.isWillCallPod?.toLocaleLowerCase() === "false" &&
                    order.properties?.isMultipleShipment?.toLowerCase() !== "true" ? (
                        <Button
                            variant="secondary"
                            {...styles.trackButton}
                            onClick={() => {
                                loadPODDataHandler(order.id, order.properties, indexNumber, order.customerPO, false);
                            }}
                        >
                            POD
                        </Button>
                    ) : order.properties.isWillCallPod?.toLocaleLowerCase() === "true" &&
                      order.properties.isWillCallPodExists?.toLocaleLowerCase() === "true" ? (
                        <Button
                            variant="secondary"
                            {...styles.trackButton}
                            onClick={() => {
                                loadPODDataHandler(order.id, order.properties, indexNumber, order.customerPO, true);
                            }}
                        >
                            POD
                        </Button>
                    ) : (
                        <>
                            {order.properties?.trackingURLs &&
                                order.properties?.isMultipleShipment?.toLowerCase() !== "true" && (
                                    <Button
                                        variant="secondary"
                                        {...styles.trackButton}
                                        onClick={() => {
                                            const trackingURLs = order.properties?.trackingURLs?.split(",");
                                            const firstUrl = trackingURLs?.length > 0 ? trackingURLs?.[0] : "";
                                            trackHandler(firstUrl);
                                        }}
                                    >
                                        {translate("Track")}
                                    </Button>
                                )}
                        </>
                    )}
                </DataTableCell>
                <DataTableCell {...styles.statusCells} data-test-selector="orderHistoryTable_tableCell_status">
                    {order.properties?.isMultipleShipment?.toLowerCase() === "true" ? (
                        <StyledWrapper {...styles.multipleDeliveryAndStatusWraaper}>
                            <Typography {...styles.multipleDeliveryHeading}>{translate("Status")}</Typography>
                            <Link {...styles.multipleLink} onClick={() => MultipleStatusClickHandler(orderNumber)}>
                                <StyledWrapper ref={getOrCreateStatusTextRefs(orderNumber)}>
                                    <Typography>{translate("Multiple")}</Typography>
                                </StyledWrapper>
                            </Link>

                            <MultipleDeliveryStatus
                                parentRef={getOrCreateStatusTextRefs(orderNumber)}
                                onHandleClose={() => closeMultipleDeliveryModal()}
                                orderNumber={orderNumber}
                                isModalIsOpen={isStatusModalIsOpen === orderNumber}
                                shipmentPackages={order.shipmentPackages}
                                properties={order.properties}
                            />
                        </StyledWrapper>
                    ) : (
                        order?.status && (
                            <StatusLableAndHeading
                                heading={translate("Status")}
                                text={order?.status}
                            />
                        )
                    )}
                </DataTableCell>
                <DataTableCell {...styles.shipToCells}>
                    <OrderDetailsKebabMenu orderNumber={order.erpOrderNumber} />
                </DataTableCell>
            </DataTableRow>
            {PODstate.isWillCallPod ? (
                <ProofOfDeliveryWillCallComponent
                    onHandleClose={closeModal}
                    modalIsOpen={PODstate.isModalOpen}
                    poNumber={PODstate.poNumber}
                />
            ) : (
                <ProofOfDeliveryComponent
                    onHandleClose={closeModal}
                    modalIsOpen={PODstate.isModalOpen}
                    poNumber={PODstate.poNumber}
                />
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummaryCard);
